import { useQuery } from '@tanstack/react-query';
import {
  FeeService,
  feesInfoKeys,
} from 'api/services/httpServices/FeeServiceNew';
import {
  starLevelKeys,
  StarLevelService,
} from 'api/services/httpServices/StarLevelService';
import { duration } from 'moment';
import { hasActiveJWT } from 'helpers/api/apiCore';
import { useUserState } from 'modules/user/UserContext';

export enum StarLevels {
  BlackHole = 'Black Hole',
  Supernova = 'Supernova',
  HyperGiant = 'Hyper Giant',
  SuperGiant = 'Super Giant',
  BrightGiant = 'Bright Giant',
  Giant = 'Giant',
  SubGiant = 'Sub Giant',
  BrownDwarf = 'Brown Dwarf',
  ProtoStar = 'Proto-star',
  Nebula = 'Nebula',
}

export function BlockFeatures() {
  const { data: plan } = useQuery({
    queryKey: feesInfoKeys.getPlanInfo(),
    queryFn: () => FeeService.getPlanInfo(),
  });

  const { data: starLevel } = useQuery({
    queryFn: StarLevelService.getStarLevel,
    queryKey: starLevelKeys.getStarLevel(),
    staleTime: duration('1', 'hour').asMilliseconds(),
  });

  return plan && starLevel
    ? (plan.activePlanId === 'pay_as_you_go' ||
        plan.activePlanId === 'trader') &&
        !(starLevel?.img === 'supernova' || starLevel?.img === 'black_hole')
    : false;
}

export function LikingDisabled() {
  const { user } = useUserState();
  const isLoggedIn = user && 'access_token' in user && hasActiveJWT(user);

  const { data: starLevel } = useQuery({
    queryFn: StarLevelService.getStarLevel,
    queryKey: starLevelKeys.getStarLevel(),
    staleTime: duration('1', 'hour').asMilliseconds(),
    enabled: !!isLoggedIn,
  });

  return isLoggedIn && starLevel ? !isGiantAndAbove(starLevel.level) : true;
}

export function isGiantAndAbove(level: StarLevels) {
  return !(
    level === StarLevels.ProtoStar ||
    level === StarLevels.Nebula ||
    level === StarLevels.BrownDwarf ||
    level === StarLevels.SubGiant
  );
}

export function PublishDisabled() {
  const { data: starLevel } = useQuery({
    queryFn: StarLevelService.getStarLevel,
    queryKey: starLevelKeys.getStarLevel(),
    staleTime: duration('1', 'hour').asMilliseconds(),
  });

  const { data: plan } = useQuery({
    queryKey: feesInfoKeys.getPlanInfo(),
    queryFn: () => FeeService.getPlanInfo(),
  });

  return plan && starLevel
    ? plan.activePlanId === 'pay_as_you_go' || !isGiantAndAbove(starLevel.level)
    : false;
}
